const multiTabInitialState = {
  multiTab: {
    paso: 0,
  },
};

export default multiTabInitialState;
